import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./property.css";
import "leaflet/dist/leaflet.css";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { addProperty, clearState } from "../../redux/Slices/AddPropertySlice";
import GoogleMapPicker from "../PublishAd/GoogleMapPicker";
import {
  fetchLevels,
  fetchPropertCategories,
  resetDynamicCategories,
  fetchPropertCategoriesChilds,
  fetchPurposes,
} from "../../redux/Slices/PropertyApisSlice";
import axios from "axios";

const AddProperty = () => {
  const { t, i18n } = useTranslation("global");
  const dispatch = useDispatch();
  const user3ayin = JSON.parse(sessionStorage.getItem("user3ayin"));
  const userID = user3ayin?.user?.id;
  const userType = user3ayin?.user?.type;
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = user3ayin?.token;
  const [previews, setPreviews] = useState({
    images: [null, null, null, null],
    files: [null, null, null, null],
  });

  const [showMap, setShowMap] = useState(false);
  // const [selectedMain, setSelectedMain] = useState("");
  // const [selectedSub, setSelectedSub] = useState("");
  // const [selectedSubSub, setSelectedSubSub] = useState("");
  const navigate = useNavigate();
  const { success, error, isLoading } = useSelector(state => state.property);
  const { purposes, levels, property_categories, dynamic_categories } =
    useSelector(state => state.properties_api);
  useEffect(() => {
    dispatch(fetchPurposes());
    dispatch(fetchLevels());
    dispatch(fetchPropertCategories());
  }, [dispatch, i18n.language]);
  // Replace selectedMain, selectedSub, selectedSubSub with this:
  const [categoryChain, setCategoryChain] = useState([]);

  // Helper to get the most specific category ID selected
  const currentCategoryId =
    categoryChain.length > 0 ? categoryChain[categoryChain.length - 1] : "";

  // Update the main effect to watch the chain rather than hardcoded vars
  useEffect(() => {
    if (currentCategoryId) {
      // This fetches the "children" for the NEXT level
      dispatch(fetchPropertCategoriesChilds(currentCategoryId));
    }
  }, [currentCategoryId, dispatch]);
  const [formdata, setFormData] = useState({
    purpose_id: "",
    property_level_id: "",
    category_id: "",
    title_ar: "",
    title_en: "",
    description: "",
    area: "",
    area_unit: "sqm",
    price: "",
    currency: "egp",
    payment_method: "",
    address_details: "",
    deposit_amount: "",
    images: [null, null, null, null],
    files: [null, null, null, null],
    latitude: "",
    longitude: "",
    location: "",
    AR_VR: "",
    video_url: "",
    feature_mark: "",
  });

  const [formSchema, setFormSchema] = useState([]);
  const [schemaLoading, setSchemaLoading] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState({});

  const handleChange = async e => {
    const { name, value } = e.target;
    const updates = { [name]: value };

    if (name === "title_ar") updates.title_en = value;

    setFormData(prev => ({ ...prev, ...updates }));
  };

  const renderSchemaField = field => {
    const sharedProps = {
      name: field.key,
      value: formdata[field.key] || "",
      required: field.required,
      onChange: handleChange,
      placeholder: field.label,
    };

    switch (field.type) {
      case "numeric_input":
      case "number":
        return (
          <input
            type="number"
            min="0"
            inputMode="numeric"
            onInput={e => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            {...sharedProps}
          />
        );
      case "dropdown":
        return (
          <select {...sharedProps}>
            <option value="" disabled>
              {t("labels.select")} {field.label}
            </option>
            {field.options?.map(opt => (
              <option key={opt.key} value={opt.key}>
                {opt.name}
              </option>
            ))}
          </select>
        );
      case "textarea":
        return <textarea rows={2} {...sharedProps} />;
      case "switch":
        return (
          <div className="form-check form-switch mt-2 d-flex align-items-center">
            <input
              className="form-check-input no-class"
              type="checkbox"
              role="switch"
              name={field.key}
              checked={formdata[field.key] === "1"}
              onChange={e =>
                setFormData(prev => ({
                  ...prev,
                  [field.key]: e.target.checked ? "1" : "0",
                }))
              }
            />
          </div>
        );
      case "email":
      case "tel":
      case "phone":
        return (
          <input
            type={field.type === "email" ? "email" : "tel"}
            {...sharedProps}
          />
        );
      case "date":
        return <input type="date" {...sharedProps} />;
      default:
        return <input type="text" {...sharedProps} />;
    }
  };

  const handleDynamicCategoryChange = async (levelIndex, selectedId) => {
    const newChain = [...categoryChain.slice(0, levelIndex), selectedId];
    setCategoryChain(newChain);
    setFormData(prev => ({ ...prev, category_id: selectedId }));
    dispatch(resetDynamicCategories(levelIndex)); // clear deeper levels in Redux
    dispatch(fetchPropertCategoriesChilds({ id: selectedId, levelIndex })); // ✅ pass levelIndex
    fetchSchema(selectedId);
  };

  // Separate function for schema fetching (cleaner)
  const fetchSchema = async catId => {
    setSchemaLoading(true);
    try {
      const res = await fetch(
        `https://app.xn--mgb9a0bp.com/api/property/form-schema?category_id=${catId}`,
        {
          headers: { "Content-Type": "application/json", Lang: i18n.language },
        },
      );
      const json = await res.json();
      if (json?.data) {
        setFormSchema(json.data);
        const newKeys = {};
        json.data.forEach(f => {
          newKeys[f.key] = f.type === "switch" ? "0" : "";
        });
        setFormData(prev => ({ ...prev, ...newKeys }));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setSchemaLoading(false);
    }
  };

  const handleFileInput = (e, key) => {
    const files = Array.from(e.target.files);
    // console.log("Uploading to:", key, files);
    if (!files.length) return;

    const currentFilesCount = formdata[key].filter(f => f !== null).length;
    if (currentFilesCount + files.length > 4) {
      toast.error(t("validation.You_can_upload_max_4_files"));
      return;
    }

    const imageTypes = ["image/jpeg", "image/png", "image/jpg"];
    const fileTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    let allowedTypes;
    if (key === "images") allowedTypes = imageTypes;
    if (key === "files") allowedTypes = fileTypes;

    // Validate file types
    const invalidFile = files.find(file => !allowedTypes.includes(file.type));
    if (invalidFile) {
      toast.error(
        `${t("only_allowed")} ${key === "files" ? "PDF, Word, Excel" : "JPG, JPEG, PNG"}`,
      );
      return;
    }

    // Fill empty slots in formdata
    setFormData(prev => {
      const updated = [...prev[key]];
      files.forEach(file => {
        const emptyIndex = updated.findIndex(f => f === null);
        if (emptyIndex !== -1) updated[emptyIndex] = file;
      });
      return { ...prev, [key]: updated };
    });

    // Fill empty slots in previews
    setPreviews(prev => {
      const updated = [...prev[key]];
      files.forEach(file => {
        const emptyIndex = updated.findIndex(f => f === null);
        if (emptyIndex !== -1)
          updated[emptyIndex] =
            key === "files" ? file.name : URL.createObjectURL(file);
      });
      return { ...prev, [key]: updated };
    });

    e.target.value = null; // reset input
  };
  const removeFile = (key, index) => {
    setFormData(prev => {
      const updated = [...prev[key]];
      updated[index] = null;
      return { ...prev, [key]: updated };
    });

    setPreviews(prev => {
      const updated = [...prev[key]];
      updated[index] = null;
      return { ...prev, [key]: updated };
    });
  };

  const getProfileData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/profileData`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
          Lang: i18n.language,
        },
      });

      setSubscriptionData(response.data.data?.user?.subscription);
      if (!subscriptionData) return;
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getProfileData();
  }, []);

  const handleSubmit = e => {
    e.preventDefault();

    if (formdata.AR_VR && !formdata.AR_VR.startsWith("https://")) {
      toast.error(t("property.AR_VRLinkInvalid"));
      return;
    }
    if (formdata.video_url && !formdata.video_url.startsWith("https://")) {
      toast.error(t("property.videoLinkInvalid"));
      return;
    }
    if (!formdata.purpose_id) {
      toast.error(`${t("property.purpose")} ${t("field")} ${t("is_required")}`);
      return;
    }
    if (!formdata.category_id) {
      toast.error(
        `${t("property.main_categories")} ${t("field")} ${t("is_required")}`,
      );
      return;
    }

    const data = new FormData();

    data.append("user_id", userID);
    Object.entries(formdata).forEach(([key, value]) => {
      if (["images", "files"].includes(key)) return;
      if (value !== null && value !== undefined) {
        data.append(key, String(value));
      }
    });

    formdata.images
      .filter(file => file instanceof File)
      .forEach(file => data.append("images[]", file));
    formdata.files
      .filter(file => file instanceof File)
      .forEach(file => data.append("files[]", file));

    // console.log("FormData contents:");
    // for (let [key, value] of data.entries()) {
    //   console.log(key, value instanceof File ? value.name : value);
    // }

    dispatch(addProperty(data));
  };

  useEffect(() => {
    if (success) {
      toast.success(t("request_added_success"), {
        onClose: () => {
          dispatch({ type: "property/clearState" });
          window.location.href = "/all_properties";
        },
      });
    } else if (error) {
      let errorMessage = t("failedToAdd");

      if (error?.data?.message) {
        errorMessage = error.data.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (typeof error === "string") {
        errorMessage = error;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      if (
        errorMessage.includes("Please complete your profile documents first")
      ) {
        toast.error(t("please_complete_your_profile_documents_first"));
        navigate("/user_profile");
      } else if (
        errorMessage.includes("plan limit") ||
        errorMessage.includes(
          "You have reached your limit. Please subscribe to a new plan",
        ) ||
        errorMessage.includes("limit reached")
      ) {
        toast.error(t("planLimitReached"));
        navigate("/packages");
      } else if (
        errorMessage.includes(
          "You have reached your ad limit. Please subscribe to a new plan",
        )
      ) {
        toast.error(t("ad_limit_reached"));
      } else {
        toast.error(errorMessage || t("failedToAdd"));
      }

      dispatch(clearState());
    }
  }, [success, error, t, dispatch, navigate]);

  return (
    <div className="form_holder">
      <Breadcrumb title={t("property.add_property")} />
      <div className="container">
        <div className="add_property py-4">
          <form className="form-style" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <h4
                  className="fw-bold my-4 position-relative"
                  style={{ fontSize: "22px" }}
                >
                  {t("property.select_category")}
                </h4>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                <label className="fw-bold">{t("property.purpose")}</label>
                <select
                  name="purpose_id"
                  onChange={handleChange}
                  value={formdata.purpose_id}
                >
                  <option value="" disabled>
                    {t("property.select_item")}
                  </option>
                  {purposes &&
                    purposes.length > 0 &&
                    purposes.map(purpose => (
                      <option key={purpose.id} value={purpose.id}>
                        {purpose.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-6 col-12">
                <label className="fw-bold">{t("property.level")}</label>
                <select
                  name="property_level_id"
                  onChange={handleChange}
                  value={formdata.property_level_id}
                >
                  <option value="" disabled>
                    {t("property.select_item")}
                  </option>
                  {levels &&
                    levels.length > 0 &&
                    levels.map(level => (
                      <option key={level.id} value={level.id}>
                        {level.name}
                      </option>
                    ))}
                </select>
              </div>
              {/* categories part */}

              {/* Level 0: Root Categories */}
              <div className="col-xl-4 col-lg-4 col-md-6 col-12 mb-3">
                <label className="fw-bold">
                  {t("property.main_categories")}
                </label>
                <select
                  value={categoryChain[0] || ""}
                  onChange={e => handleDynamicCategoryChange(0, e.target.value)}
                >
                  <option value="" disabled>
                    {t("property.select_item")}
                  </option>
                  {property_categories?.map(cat => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Levels 1 to N: Dynamic Sub-Categories */}
              {dynamic_categories.map((levelData, index) => (
                <div
                  className="col-xl-4 col-lg-4 col-md-6 col-12 mb-3"
                  key={index}
                >
                  <label className="fw-bold">
                    {t("property.sub_categories")} {index + 1}
                  </label>
                  <select
                    value={categoryChain[index + 1] || ""}
                    onChange={e =>
                      handleDynamicCategoryChange(index + 1, e.target.value)
                    }
                  >
                    <option value="" disabled>
                      {t("property.select_item")}
                    </option>
                    {levelData.map(cat => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <hr />
              </div>
              {schemaLoading ? (
                <div className="col-12 text-center my-4">
                  <p className="mt-2 text-center">
                    {t("loading_unit_features_fields")}
                  </p>
                </div>
              ) : formSchema.length > 0 ? (
                <>
                  {formSchema.filter(field => field.type !== "switch").map(field => (
                    <div
                      key={field.key}
                      className="col-xl-3 col-lg-3 col-md-6 col-12 mb-3"
                    >
                      <label className="fw-bold d-block">
                        {field.label}
                        {field.required && (
                          <span className="text-danger ms-1">*</span>
                        )}
                      </label>
                      {renderSchemaField(field)}
                    </div>
                  ))}

                  {/* Grouped switch fields (Amenities & Features) in a compact layout */}
                  {formSchema.some(field => field.type === "switch") && (
                    <>
                      <div className="col-xl-12 col-lg-12 col-md-12 col-12 mt-3 mb-2">
                        <h5 className="fw-bold text-dark">
                          {t("property.amenities_features") || "المميزات والخدمات"}
                        </h5>
                        <hr />
                      </div>
                      <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                        <div className="row amenities-row">
                          {formSchema.filter(field => field.type === "switch").map(field => (
                            <div
                              key={field.key}
                              className="col-xl-3 col-lg-3 col-md-4 col-6 mb-3"
                            >
                              <label className="amenity-toggle-card">
                                <input
                                  type="checkbox"
                                  className="amenity-toggle-input"
                                  name={field.key}
                                  checked={formdata[field.key] === "1"}
                                  onChange={e =>
                                    setFormData(prev => ({
                                      ...prev,
                                      [field.key]: e.target.checked ? "1" : "0",
                                    }))
                                  }
                                />
                                <span className="amenity-toggle-label">
                                  {field.label}
                                  {field.required && (
                                    <span className="text-danger ms-1">*</span>
                                  )}
                                </span>
                                <span className="amenity-toggle-switch"></span>
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}

                  <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                    <hr />
                  </div>
                </>
              ) : (
                <div className="no_data bg-white py-5 border rounded-2 my-3 text-center">
                  <h5 className="mb-2 text-sm">{t("no_data_exists")}</h5>
                  <h5 className="mb-0 text-sm">
                    {t(
                      "please_select_sub_categories_loading_unit_features_fields",
                    )}
                  </h5>
                </div>
              )}

              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <h4
                  className="fw-bold my-4 position-relative"
                  style={{ fontSize: "22px" }}
                >
                  {t("property.property_details")}
                </h4>
              </div>
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <label className="fw-bold">{t("property.unitNameAr")}</label>
                <input
                  type="text"
                  name="title_ar"
                  required
                  onChange={handleChange}
                  value={formdata.title_ar}
                />
              </div>

              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <label className="fw-bold">{t("property.area")}</label>
                <div
                  className="d-flex align-items-stretch"
                  style={{ margin: "8px 0" }}
                >
                  <input
                    type="number"
                    min="0"
                    onInput={e => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, ""); // only digits
                    }}
                    required
                    name="area"
                    onChange={handleChange}
                    value={formdata.area}
                    style={{
                      margin: 0,
                      flex: 1,
                      borderStartEndRadius: 0,
                      borderEndEndRadius: 0,
                    }}
                  />
                  <select
                    name="area_unit"
                    onChange={handleChange}
                    value={formdata.area_unit}
                    style={{
                      margin: 0,
                      width: "auto",
                      minWidth: "130px",
                      borderStartStartRadius: 0,
                      borderEndStartRadius: 0,
                      borderInlineStart: "none",
                    }}
                  >
                    <option value="sqm">{t("property.unit_sqm")}</option>
                    <option value="feddan">{t("property.unit_feddan")}</option>
                    <option value="carat">{t("property.unit_carat")}</option>
                    <option value="sahm">{t("property.unit_sahm")}</option>
                  </select>
                </div>
              </div>
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <hr />
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <label className="fw-bold">{t("create_ad.price")}</label>
                <div
                  className="d-flex align-items-stretch"
                  style={{ margin: "8px 0" }}
                >
                  <input
                    type="number"
                    name="price"
                    min="0"
                    inputMode="numeric"
                    onInput={e => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, ""); // only digits
                    }}
                    onChange={handleChange}
                    value={formdata.price}
                    style={{
                      margin: 0,
                      flex: 1,
                      borderStartEndRadius: 0,
                      borderEndEndRadius: 0,
                    }}
                  />
                  <select
                    name="currency"
                    onChange={handleChange}
                    value={formdata.currency}
                    style={{
                      margin: 0,
                      width: "auto",
                      minWidth: "130px",
                      borderStartStartRadius: 0,
                      borderEndStartRadius: 0,
                      borderInlineStart: "none",
                    }}
                  >
                    <option value="egp">{t("property.currency_egp")}</option>
                    <option value="usd">{t("property.currency_usd")}</option>
                  </select>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <label className="fw-bold">{t("property.paymentMethod")}</label>
                <select
                  type="text"
                  name="payment_method"
                  onChange={handleChange}
                  value={formdata.payment_method}
                >
                  <option value="" disabled>
                    {t("property.select_item")}
                  </option>
                  <option value="cash">{t("property.paymentCash")}</option>
                  <option value="installments">
                    {t("property.paymentInstallments")}
                  </option>
                  <option value="monthly">
                    {t("property.paymentMonthly")}
                  </option>
                </select>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <label className="fw-bold">{t("property.deposit")}</label>
                <input
                  type="number"
                  min="0"
                  onInput={e => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, ""); // only digits
                  }}
                  name="deposit_amount"
                  onChange={handleChange}
                  value={formdata.deposit_amount}
                />
              </div>
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <label className="fw-bold">
                  {t("property.detailedAddress")}
                </label>
                <textarea
                  name="address_details"
                  rows={1}
                  style={{ height: "44px", minHeight: "44px" }}
                  onChange={handleChange}
                  value={formdata.address_details}
                  placeholder={`(${t("property.addressRegion")} - ${t(
                    "property.addressStreet",
                  )} - ${t("property.addressLandmark")})`}
                ></textarea>
              </div>
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <label className="fw-bold">{t("create_ad.uploadImages")}</label>
                <div className="row">
                  {previews.images.map((fileName, index) => (
                    <div
                      className="col-xl-3 col-lg-3 col-md-6 col-6"
                      key={index}
                    >
                      <div className="photo_wrapper">
                        <input
                          type="file"
                          multiple
                          accept=".png,.jpg,.jpeg"
                          onChange={e => handleFileInput(e, "images")}
                        />
                        {fileName ? (
                          <>
                            <img src={fileName} alt="image" />
                            <span
                              className="remove-file"
                              onClick={() => removeFile("images", index)}
                            >
                              ×
                            </span>
                            <span className="text-sm">
                              {t("create_ad.uploadedFile")}
                            </span>
                          </>
                        ) : (
                          <>
                            <img src="/camera.png" alt="upload" />
                            <span className="text-sm">
                              {t("create_ad.uploadImage")}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <label className="fw-bold">{t("create_ad.location")}</label>
                <input
                  type="text"
                  name="location"
                  value={formdata.location}
                  onChange={handleChange}
                  required
                  placeholder={t("create_ad.useCurrentLocation")}
                />

                <button
                  type="button"
                  className="btn btn-outline-primary mt-2"
                  onClick={() => setShowMap(true)}
                >
                  {t("property.pickFromMap")}
                </button>

                {showMap && (
                  <div className="mt-3">
                    <GoogleMapPicker
                      onSelect={({ latitude, longitude, location }) => {
                        setFormData(prev => ({
                          ...prev,
                          latitude,
                          longitude,
                          location,
                        }));
                        setShowMap(false);
                      }}
                    />
                  </div>
                )}
              </div>
              {subscriptionData?.vr_tours > "0" && (
                <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                  <label className="fw-bold">{t("create_ad.arVr")}</label>
                  <input
                    type="text"
                    name="AR_VR"
                    placeholder={`${t("create_ad.link")} VR/AR`}
                    onChange={handleChange}
                    value={formdata.AR_VR}
                  />
                </div>
              )}
              {subscriptionData?.video === true && (
                <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                  <label className="fw-bold">{t("property.video_url")}</label>
                  <input
                    type="text"
                    name="video_url"
                    placeholder={t("create_ad.link")}
                    onChange={handleChange}
                    value={formdata.video_url}
                  />
                </div>
              )}
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <label className="fw-bold">
                  {t("property.distinctive_signs")}
                </label>
                <input
                  type="text"
                  name="feature_mark"
                  onChange={handleChange}
                  value={formdata.feature_mark}
                />
              </div>
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <label className="fw-bold">
                  {t("create_ad.additional_details")}
                </label>
                <div className="row">
                  {previews.files.map((fileName, index) => (
                    <div
                      className="col-xl-3 col-lg-3 col-md-6 col-6"
                      key={index}
                    >
                      <div className="photo_wrapper">
                        <input
                          type="file"
                          multiple
                          accept=".pdf,.doc,.docx,.xls,.xlsx"
                          onChange={e => handleFileInput(e, "files")}
                        />
                        {fileName ? (
                          <>
                            <img src="/file.png" alt="file" />
                            <span>{fileName}</span>
                            <span
                              className="remove-file"
                              onClick={() => removeFile("files", index)}
                            >
                              ×
                            </span>
                            <span className="text-sm">
                              {t("create_ad.uploadedFile")}
                            </span>
                          </>
                        ) : (
                          <>
                            <img src="/camera.png" alt="upload" />
                            <span className="text-sm">
                              {t("create_ad.uploadFile")}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <label className="fw-bold">{t("property.description")}</label>
                <textarea
                  name="description"
                  value={formdata.description}
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <div className="form_btn">
                  <button type="submit" disabled={isLoading}>
                    {isLoading ? t("loading") : t("create_ad.publishNow")}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddProperty;
